import { Component, EventEmitter, Output } from '@angular/core';
import { IconDefinition, faUpload } from '@fortawesome/pro-duotone-svg-icons';
import { Store } from '@ngxs/store';
import { FileInfo, FileRestrictions, SelectEvent, UploadComponent } from '@progress/kendo-angular-upload';
import { BehaviorSubject } from 'rxjs';
import { NotificationType } from 'src/app/samwebDescription/samweb/notification/notificationType';
import { ToastUserInfoNotification } from 'src/app/store/notification/notification-toastr/notification-toastr.actions';
import { AudioFile } from '../audio-file';

@Component({
   selector: 'samweb-greeting-upload-bar-dialog',
   templateUrl: './greeting-upload-bar-dialog.component.html',
   styleUrls: ['./greeting-upload-bar-dialog.component.scss'],
})
export class GreetingUploadBarDialogComponent {
   @Output()
   public uploadGreeting = new EventEmitter<AudioFile>();

   public uploadIcon: IconDefinition = faUpload;
   public fileRestrictions: FileRestrictions = { allowedExtensions: ['.wav', '.mp3'] };

   public counter = 0;
   public isDropListEntered$ = new BehaviorSubject<boolean>(false);

   constructor(public store: Store) {}

   dropListEntered(ev: Event) {
      ev.preventDefault();
      this.counter++;
      this.isDropListEntered$.next(true);
   }

   dropListExited() {
      this.counter--;
      if (this.counter === 0) {
         this.isDropListEntered$.next(false);
      }
   }

   public onDrop() {
      this.counter = 0;
      this.isDropListEntered$.next(false);
   }

   onUploadButtonClick(upload: UploadComponent) {
      upload.fileSelect.nativeElement.click();
   }

   public onSelect(ev: SelectEvent): void {
      if (!ev.files.every((file) => file.extension.toLowerCase().includes('wav') || file.extension.toLowerCase().includes('mp3'))) {
         this.store.dispatch(
            new ToastUserInfoNotification(
               NotificationType.WARN,
               'common.settings.agent_greetings.toast.wrong_format.title',
               `common.settings.agent_greetings.toast.wrong_format.message`
            )
         );
         return;
      }

      ev.files.forEach((file: FileInfo) => {
         if (file.rawFile) {
            const reader = new FileReader();
            reader.onloadend = () => {
               // seems like basic conversion is working best for upload of audio
               const content = btoa(<string>reader.result);
               const uploadedGreeting: AudioFile = {
                  content: content,
                  name: file.name,
               };
               this.uploadGreeting.emit(uploadedGreeting);
               this.isDropListEntered$.next(false);
            };
            reader.readAsBinaryString(file.rawFile);
         }
      });
   }
}
